import React from "react";
import { Link } from "react-router-dom";

export default function HoteleriaBrasil({ bgColor }) {
  return (
    <>
      <section
        id="hoteleria"
        className={`contact-us ptb-100 ${bgColor ? "gray-light-bg" : ""}`}
      >
        <section className="team-member-section ptb-100">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-7 col-md-8">
                <div className="section-heading text-center mb-4">
                  <h2>HOTELERIA EXCLUSIVA</h2>
                  <h3>All inclusive</h3>
                  <p className="lead">
                    En pleno corazón de Camboriú te alojaremos en los hoteles
                    para jóvenes más exclusivos del mercado. Los mismos cuentan
                    con prestaciones de primerísimo nivel, con toda la
                    tecnología, las comodidades y todos los servicios que los
                    pasajeros necesitan para poder tener una estadía única e
                    inolvidable.
                  </p>
                  {/* <p className="lead">
                    {" "}
                    Consultorio Médico/Calefacción Central Cajas de Seguridad /
                    Vista al mar Desfibrilador / Piscina / Play Room Tarjeta
                    Magnética / Plancha Secador de Pelo / Smart TV Wi-Fi/Open
                    Bar 24hs Drugstore/Discoteca / UP Look
                  </p> */}
                </div>
              </div>
            </div>
            <div className="row justify-content-center">
              <div className="col-lg-4 col-md-6 col-sm-6">
                <div className="single-team-member position-relative my-lg-3 my-md-3 my-sm-0">
                  <div className="team-image">
                    <img
                      src="assets/img/brasil/hotelgenova.jpg"
                      alt="Team Members"
                      className="img-fluid rounded"
                    />
                  </div>
                  <div className="team-info text-white rounded d-flex flex-column align-items-center justify-content-center">
                    <h5 className="mb-0">Hotel Genova</h5>
                    <h6>Camboriu Centro</h6>
                    <ul className="list-inline team-social social-icon my-4 text-white">
                      <li className="list-inline-item">
                        <Link
                          target="_blank"
                          rel="noopener noreferrer"
                          to="https://www.facebook.com/hotelgenovabc"
                        >
                          <span className="ti-facebook"></span>
                        </Link>
                      </li>
                      <li className="list-inline-item">
                        <Link
                          target="_blank"
                          rel="noopener noreferrer"
                          to="https://www.instagram.com/hotelgenovabc/"
                        >
                          <span className="ti-instagram"></span>
                        </Link>
                      </li>
                    </ul>
                    <a
                      href="https://hotelgenova.com.br"
                      target="_blank"
                      rel="noreferrer"
                      className="btn app-store-btn"
                    >
                      Ver hotel
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-sm-6">
                <div className="single-team-member position-relative my-lg-3 my-md-3 my-sm-0">
                  <div className="team-image">
                    <img
                      src="assets/img/brasil/Hm-hotel.jpg"
                      alt="Team Members"
                      className="img-fluid rounded"
                    />
                  </div>
                  <div className="team-info text-white rounded d-flex flex-column align-items-center justify-content-center">
                    <h5 className="mb-0">Hm hotel</h5>
                    <h6>2 Cuadras de la Playa</h6>
                    <ul className="list-inline team-social social-icon my-4 text-white">
                      <li className="list-inline-item">
                        <Link
                          target="_blank"
                          rel="noopener noreferrer"
                          to="http://facebook.com/hmhotelbc"
                        >
                          <span className="ti-facebook"></span>
                        </Link>
                      </li>
                      <li className="list-inline-item">
                        <Link
                          target="_blank"
                          rel="noopener noreferrer"
                          to="http://instagram.com/hmhotelbc"
                        >
                          <span className="ti-instagram"></span>
                        </Link>
                      </li>
                    </ul>
                    <a
                      href="https://hmhotel.com.br/"
                      target="_blank"
                      rel="noreferrer"
                      className="btn app-store-btn"
                    >
                      Ver hotel
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </section>
    </>
  );
}
